import React, { ReactNode } from 'react';

import './custom-lesson-view__wrapper.scss';

interface Props {
    children: ReactNode;
}

export const CustomLessonViewWrapper = React.memo(({ children }: Props) => {
    return <div className="custom-lesson-view__wrapper">{children}</div>;
});
